module.exports = __webpack_public_path__ + "img/kachel_BEWEGLICHKEIT_freeedomkapseln.317feace.png";